import React from 'react';
import PricingPage from '@/components/monetization/PricingPage';

export default function Pricing() {
  return <PricingPage isPublic={true} />;
}
